<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Cost & Acquisition
        <small>Create Channel</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Cost & Acquisition</a></li>
        <li class="active">Create Channel</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-sm-6 col-sm-offset-3">
                <form role="form" v-on:submit.prevent="createChannel">
                  <div class="form-group">
                    <label for="name">Channel Name</label>
                    <input type="text" v-model.trim="name" class="form-control" id="name" placeholder="Channel name">
                  </div>
                  <div v-if="submitting" class="form-loader"><img src="/static/img/loader.gif" /></div>
                  <div class="form-group">
                    <p v-if="!submitting" :class="message.style">{{message.text}}</p>
                  </div>
                  <div class="box-footer">
                    <button type="submit" class="btn btn-primary">Submit</button>
                  </div>
                </form>

                <div class="loader" v-if="loading">
                  <img src="/static/img/loader.gif" />
                </div>

                <p class="error" v-if="!loading && !channels.length">Channels could not be retrieved</p>

                <div v-if="channels.length && !loading">
                  <h3>All channels</h3>
                  <table class="table table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Name</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(channel, index) in channels" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{channel.name}}</td>
                        <td><i class="fa fa-pencil edit" aria-hidden="true"></i></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import api from '../../../utils/api'
import { showMessage } from '../../../utils'

export default {
  data () {
    return {
      name: '',
      submitting: false,
      loading: true,
      channels: [],
      message: {
        style: '',
        text: ''
      }
    }
  },
  methods: {
    createChannel () {
      const { name } = this
      if (!name) {
        return showMessage(this, 'error', 'Channel name is compulsory')
      }
      this.submitting = true
      api.buildRequest('channel', 'post', { name })
        .then(response => {
          this.submitting = false
          const type = response.status === 201 ? 'success' : 'error'
          showMessage(this, type, response.data.payload.msg)
          if (type === 'success') {
            this.name = ''
            this.channels.push(response.data.payload.details)
          }
        }).catch(() => {
          this.submitting = false
        })
    },

    getAllChannels () {
      // get all created channels
      api.buildRequest('channel', 'get')
        .then(response => {
          const { status, data } = response
          if (status === 200) {
            this.channels = data.payload
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.getAllChannels()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .edit {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Channel.vue?fd10f782